import React, { useMemo } from 'react'
import { Icon, l } from '@manychat/manyui'

import { PlacehodlerBlock } from 'common/builder/components/chart/FlowChart/components/Block/generic/Placeholder/Placehodler'
import { BlockComponent } from 'common/builder/components/chart/FlowChart/components/Block/types'
import { FlowChartPlaceholderBlockBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartPlaceholderBlockBuilder'
import { FlowChartPlaceholderBlock } from 'common/builder/components/chart/FlowChart/types/FlowChartPlaceholderBlock'

export const FallbackGenericBlock: BlockComponent = ({ block: { id, type }, ...passProps }) => {
  const block: FlowChartPlaceholderBlock = useMemo(
    () =>
      new FlowChartPlaceholderBlockBuilder(id)
        .withText(l.translate('Unknown block: {type}', { type }))
        .withIcon(Icon.Question)
        .build(),
    [id, type],
  )

  return <PlacehodlerBlock block={block} {...passProps} />
}
